import { StoryblokCtaCenterAlign } from './StoryblokCtaCenterAlign'

import { createCtaCenterAlign } from './__mocks__/ctaCenterAlign'

export { createCtaCenterAlign }

// Re-export for backward compatibility
export const dummyBlokCtaCenterAlignPrimaryStoryblok = createCtaCenterAlign()
export const dummyBlokCtaCenterAlignSecondaryStoryblok = createCtaCenterAlign({
  buttonStyle: 'secondary',
})

export default StoryblokCtaCenterAlign
